import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MatrizCenario } from 'types/Relatorios/Matriz';

export interface MatrizDataAnalisada {
  mes: number;
  ano: number;
  dia: number;
}

export interface RelatoriosMatrizState {
  mes: number;
  ano: number;
  dia: number;
  cenario: MatrizCenario;
}

const now = new Date();
const initialState: RelatoriosMatrizState = {
  mes: now.getMonth() + 1,
  ano: now.getFullYear(),
  dia: now.getDate(),
  cenario: 'base',
};

const relatoriosMatrizSlice = createSlice({
  name: 'relatoriosMatriz',
  initialState,
  reducers: {
    setDataAnalisada: (state, action: PayloadAction<MatrizDataAnalisada>) => {
      state.mes = action.payload.mes;
      state.ano = action.payload.ano;
      state.dia = action.payload.dia;
    },
    setCenario: (state, action: PayloadAction<MatrizCenario>) => {
      state.cenario = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setDataAnalisada, setCenario, reset,
} = relatoriosMatrizSlice.actions;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fatiaMatriz = (state: any): RelatoriosMatrizState => state.relatoriosMatriz;
/**
 * Memorizado: devolve o mesmo objeto enquanto a data não muda. O `useSelector` compara por
 * referência, e um objeto novo a cada chamada desenharia de novo, a cada ação do Redux (RTK Query,
 * polling), toda tela que lê a data.
 */
export const selectMatrizDataAnalisada = createSelector(
  [
    (state: unknown) => fatiaMatriz(state).mes,
    (state: unknown) => fatiaMatriz(state).ano,
    (state: unknown) => fatiaMatriz(state).dia,
  ],
  (mes, ano, dia): MatrizDataAnalisada => ({ mes, ano, dia }),
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectMatrizCenario = (state: any): MatrizCenario => (
  state.relatoriosMatriz.cenario
);

export default relatoriosMatrizSlice.reducer;
